<script setup lang="ts">

import type { IProductPostDTO } from '~/interfaces/product/IProductPageData';

const props = defineProps<{
  post: IProductPostDTO
}>()

const {
  post,
} = toRefs(props)
</script>

<template>
  <div class="cmag-article mag-item">
    <a
       :href="post.url"
       :title="post.title">
      <div class="cmag-article__image image">
        <img :src="post.imageUrl" :alt="post.title" >
      </div>
      <div class="cmag-article__description">
        <div class="pt-h">
          <h2>
            <span class="size--body weight--intermedium">{{ post.title }}</span>
          </h2>
        </div>
        <div class="pt-h">
          <h2 class="cmag-article__abstract">
            <span class="size--headline">{{ post.abstract }}</span>
          </h2>
        </div>
      </div>
      <div class="df fww mt-h hidden-hover">
        <span
            v-for="(tag, index) in post.postTags"
            :key="index"
            :class="`label label--big label--highlight-2 mr-h mb-h`">
            {{ $t('www.magazine.tags', {'tag': tag}) }}
        </span>
      </div>
    </a>
  </div>
</template>
